// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateMexicanState(stateValue: string): ?UserInputValidationError {
  return stateValue && stateValue.length > 0 ? VALID : { id: 'empty' };
}
